import { useEffect, useState } from "react";
import { API } from "aws-amplify";
import { notifyHSMSDataMutation } from "./HSMSDataSync";

export function logOut()
{
	localStorage.clear();
	sessionStorage.clear();
	document.location.href = "logout.php";
}

export function getCookie(name) {
    var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
}

export function setCookie(cookieName, cookieValue)
{
	document.cookie = cookieName + "=" + cookieValue + "; path=/";
}

export function capitalizeFirstLetters(string) {
	const words = string.replace("&", " & ").split(" ");

	for (let i = 0; i < words.length; i++) {
		if(words[i].length === 0) continue;
		
		const first_letter = words[i][0].toUpperCase();
		const rest_of_word = (words[i].length <= 3) ? words[i].substr(1) : words[i].substr(1).toLowerCase();
	    words[i] = first_letter + rest_of_word;
	}
	
	return words.join(" ");
}

export function createCommaSeparatedListFromArray(arrayWithList) {
	const all_but_one_element_in_array = arrayWithList.slice(0, -1);
	const all_but_one_element_with_commas_string = all_but_one_element_in_array.join(', ');
	const last_element_in_array_string = arrayWithList.slice(-1)[0];

	const array_with_comma_separated_list_and_last_element = [all_but_one_element_with_commas_string, last_element_in_array_string];
	const final_list_string = array_with_comma_separated_list_and_last_element.join(arrayWithList.length < 2 ? '' : ' and ')
	return final_list_string;
}

export function timeSince(time_stamp) {
	// Split time stamp into array of each component of the date/time
	var t = time_stamp.split(/[- :]/);

	// Apply each element to the Date function
	var date = new Date(Date.UTC(t[0], t[1]-1, t[2], t[3], t[4], t[5]));
	
	var seconds = Math.floor((new Date() - date) / 1000);
	
	// Check if interval is in years, months, days, hours, min, seconds
	// Then return the difference
	var interval = seconds / 31536000;
	
	if (interval > 1) {
		return Math.floor(interval) + " years";
	}
	
	interval = seconds / 2592000;
	
	if (interval > 1) {
		return Math.floor(interval) + " months";
	}
	
	interval = seconds / 86400;
	
	if (interval > 1) {
		return Math.floor(interval) + " days";
	}
	
	interval = seconds / 3600;
	
	if (interval > 1) {
		return Math.floor(interval) + " hours";
	}
	
	interval = seconds / 60;
	
	if (interval > 1) {
		return Math.floor(interval) + " minutes";
	}
	
	return Math.floor(seconds) + " seconds";
}

export function formatTime(timestamp) {
	if(!timestamp) return "--:--";

	const date = new Date('1989-06-29T' + timestamp);

	const hour = date.getHours();
	const hour_in_twelve_hour_day = hour > 12 ? hour - 12 : hour;
	const minute = ('0' + date.getMinutes()).slice(-2);
	const ampm = hour >= 12 ? 'pm' : 'am';

	return `${hour_in_twelve_hour_day}:${minute}${ampm}`;
}

export function convertTimeToNumber(time) {
	const hours = Number(time.split(':')[0]) * 60;
	const minutes = Number(time.split(':')[1]);
	return hours + minutes;
}

export function timesAreOverlapping(start_time1, end_time1, start_time2, end_time2) {
	if(!start_time1 || !end_time1 || !start_time2 || !end_time2) return false;
	
	const a = convertTimeToNumber(start_time1);
	const b = convertTimeToNumber(end_time1);

	const c = convertTimeToNumber(start_time2);
	const d = convertTimeToNumber(end_time2);

	if (a < d && b > c) return true;

	return false;
}

export function JSONexists(name, type = "local")
{
	var jsonData = (type === "session") ? sessionStorage.getItem(name) : localStorage.getItem(name);
	
	if(!jsonData || jsonData === null || jsonData === 'null' || jsonData === 'undefined')
	{
		return false;
	}
	else
	{
		return true;
	}
}

export function getJSONFromStorage(json_name, parse_bool, type = "local")
{
	var json_data;
	
	if(!JSONexists(json_name, type)) return null;
	
	if(parse_bool === true)
	{
		if(type === "local")
		{
			json_data = JSON.parse(localStorage.getItem(json_name));
		}
		else if(type === "session")
		{
			json_data = JSON.parse(sessionStorage.getItem(json_name));
		}
	}
	else
	{
		if(type === "local")
		{
			json_data = localStorage.getItem(json_name);
		}
		else if(type === "session")
		{
			json_data = sessionStorage.getItem(json_name);
		}
		
	}
	
	return json_data;
}

export function isObject(obj)
{
	return typeof obj === 'object' && obj !== null;
}

export function isEmpty(obj) 
{
	if(!obj || obj === 'null' || obj === 'undefined') return true;
	if(Array.isArray(obj) && obj.length === 0) return true;
	
    for(var key in obj) 
    {
        return false;
    }
    
    return true;
}

export function shuffleArray(array) {
	var currentIndex = array.length, temporaryValue, randomIndex;
	
	// While there remain elements to shuffle...
	while (0 !== currentIndex)
	{
		// Pick a remaining element...
		randomIndex = Math.floor(Math.random() * currentIndex);
		currentIndex -= 1;
		
		// And swap it with the current element.
		temporaryValue = array[currentIndex];
		array[currentIndex] = array[randomIndex];
		array[randomIndex] = temporaryValue;
	}
	
	return array;
}

export function createUniqueObjectID(lengthOfID, obj = {}) {
	let result;
	
	const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	const charactersLength = characters.length;
	
	do {
	   result = '';
	   
	   for( var i = 0; i < lengthOfID; i++ )
	   {
	      result += characters.charAt(Math.floor(Math.random() * charactersLength));
	   }
	} while(result in obj);
	
	return result;
}

export function calculateStudentRequestStats(studentRequests = [], studentID = null, sections = [], courses = [], scheduleInfo = {}) {
	const active_request_groups = (Array.isArray(studentRequests) ? studentRequests : []).reduce((results, request_group) => {
		if(!request_group) return results;

		const course_requests = Array.isArray(request_group.course_requests)
			? request_group.course_requests
			: (request_group.course_id ? [request_group] : []);
		const active_course_requests = course_requests.filter(request => request && request.is_deleted !== '1');
		const primary_request = active_course_requests.find(request => getCourseRequestOrder(request) === '1');
		if(!primary_request || !isPrimaryCourseRequest(primary_request, request_group)) return results;

		results.push({primary_request, course_requests: active_course_requests});
		return results;
	}, []);

	const matched_student_requests = active_request_groups.reduce((results, request_group) => {
		const matching_request = request_group.course_requests.find(request => {
			const request_is_inclusion = `${request.is_inclusion || '0'}` === '1';
			return sections.some(section => (
				Array.isArray(section.course_periods) &&
				section.course_periods.length > 0 &&
				`${section.course_id}` === `${request.course_id}` &&
				Array.isArray(section.student_list) &&
				section.student_list.some(section_student_id => `${section_student_id}` === `${studentID}`) &&
				(`${scheduleInfo?.separate_ICR_codes}` !== '0' || (`${section.is_inclusion || '0'}` === '1') === request_is_inclusion)
			));
		});
		const primary_course_id = request_group.primary_request.course_id;
		const course_info = courses.find(course => `${course.course_id}` === `${primary_course_id}`);
		const course_credits = (course_info) ? parseFloat(course_info.credits) : 0;

		if(matching_request)
		{
			results.matched_requests++;
			results.matched_credits += course_credits;
		}

		results.total_credits += course_credits;
		return results;
	}, {'matched_requests':0, 'matched_credits':0, 'total_credits':0});

	return {
		...matched_student_requests,
		total_requests: active_request_groups.length,
		matched_credits: Math.round(matched_student_requests.matched_credits * 100) / 100,
		total_credits: Math.round(matched_student_requests.total_credits * 100) / 100,
	};
}

const requestPriorityHasValue = (value) => value !== undefined && value !== null && `${value}` !== '';

export function getCourseRequestOrder(courseRequest = {}) {
	if(requestPriorityHasValue(courseRequest?.order)) return `${courseRequest.order}`;
	if(requestPriorityHasValue(courseRequest?.request_order)) return `${courseRequest.request_order}`;
	if(requestPriorityHasValue(courseRequest?.priority)) return `${courseRequest.priority}`;

	return '1';
}

export function getRequestGroupPriority(courseRequest = {}, requestGroup = {}) {
	if(requestPriorityHasValue(requestGroup?.priority)) return `${requestGroup.priority}`;
	if(requestPriorityHasValue(courseRequest?.request_group_priority)) return `${courseRequest.request_group_priority}`;
	if(requestPriorityHasValue(courseRequest?.group_priority)) return `${courseRequest.group_priority}`;

	return '1';
}

export function getCourseRequestPriority(courseRequest = {}, requestGroup = {}) {
	return getCourseRequestOrder(courseRequest, requestGroup);
}

export function isAlternateCourseRequest(courseRequest = {}, requestGroup = {}) {
	return getCourseRequestOrder(courseRequest) !== '1' || getRequestGroupPriority(courseRequest, requestGroup) !== '1';
}

export function isPrimaryCourseRequest(courseRequest = {}, requestGroup = {}) {
	return !isAlternateCourseRequest(courseRequest, requestGroup);
}

export function getCourseRequestsFromStudentRequests(studentRequests = [], {includeDeleted = true, includeAlternates = true} = {}) {
	if(!Array.isArray(studentRequests)) return [];

	return studentRequests.reduce((results, request_group) => {
		if(!request_group) return results;

		const course_requests = (Array.isArray(request_group.course_requests))
			? request_group.course_requests
			: (request_group.course_id ? [request_group] : []);

		course_requests.forEach(course_request => {
			if(!course_request) return;
			if(!includeDeleted && course_request.is_deleted === '1') return;
			if(!includeAlternates && !isPrimaryCourseRequest(course_request, request_group)) return;

			const request_priority = getCourseRequestPriority(course_request, request_group);
			const request_group_priority = getRequestGroupPriority(course_request, request_group);
			const course_request_with_priority = {
				...course_request,
				priority: request_priority,
				request_order: request_priority,
				request_group_priority,
				group_priority: request_group_priority,
			};

			results.push(course_request_with_priority);
		});

		return results;
	}, []);
}

export function findCourseRequestInStudentRequests(studentRequests = [], course_id, {includeDeleted = true, isInclusion = null} = {}) {
	if(!Array.isArray(studentRequests) || !course_id) return null;
	const should_match_inclusion = isInclusion === null ? null : isInclusion === true || `${isInclusion}` === '1';

	for(let request_group_index = 0; request_group_index < studentRequests.length; request_group_index++)
	{
		const request_group = studentRequests[request_group_index];
		if(!request_group) continue;

		const course_requests = (Array.isArray(request_group.course_requests))
			? request_group.course_requests
			: (request_group.course_id ? [request_group] : []);

		for(let request_index = 0; request_index < course_requests.length; request_index++)
		{
			const request_info = course_requests[request_index];

			if(!request_info || request_info.course_id !== course_id) continue;
			if(!includeDeleted && request_info.is_deleted === '1') continue;
			if(should_match_inclusion !== null && (`${request_info.is_inclusion || '0'}` === '1') !== should_match_inclusion) continue;

			return {
				request_group,
				request_group_index,
				request_info,
				request_index,
				priority: getCourseRequestPriority(request_info, request_group),
			};
		}
	}

	return null;
}

const STUDENT_FULLNESS_PATH_SCHEDULE_TYPES = new Set(['daily', 'ab_skinny', 'custom']);
const STUDENT_FULLNESS_QUARTERS = ['1', '2', '3', '4'];

const normalizeScheduleMatchID = (value) => {
	if(value === null || value === undefined) return '';
	return `${value}`;
}

const getCourseLookupByID = (courses = []) => {
	return courses.reduce((results, course_info) => {
		if(course_info && course_info.course_id !== null && course_info.course_id !== undefined) results[normalizeScheduleMatchID(course_info.course_id)] = course_info;
		return results;
	}, {});
}

const getScheduleStructureDayKeys = (schedule_structure = {}) => {
	return Object.keys(schedule_structure).sort((day_a, day_b) => parseInt(day_a, 10) - parseInt(day_b, 10));
}

const getScheduleTimeSortValue = (time) => {
	if(!time) return Number.MAX_SAFE_INTEGER;
	return convertTimeToNumber(time);
}

const getPreparedScheduleRowsForDay = (scheduleStructureData = {}, day) => {
	const day_periods = scheduleStructureData?.schedule_structure?.[day] || [];
	const schedule_periods = scheduleStructureData?.schedule_periods || {};

	return day_periods.reduce((results, day_period_info) => {
		const schedule_period_id = day_period_info?.schedule_period_id || day_period_info?.period_id;
		const course_period_id = day_period_info?.course_period_id;
		if(!schedule_period_id || !course_period_id) return results;

		const schedule_period_info = schedule_periods[schedule_period_id] || schedule_periods[normalizeScheduleMatchID(schedule_period_id)];
		if(!schedule_period_info || schedule_period_info.include_in_match !== '1') return results;

		results.push({
			day: normalizeScheduleMatchID(day),
			schedule_period_id: normalizeScheduleMatchID(schedule_period_id),
			course_period_id: normalizeScheduleMatchID(course_period_id),
			start_time: schedule_period_info.start_time,
			end_time: schedule_period_info.end_time,
			period_order: parseInt(day_period_info.period_order || schedule_period_info.period_order || schedule_period_info.period_name || '0', 10),
		});

		return results;
	}, []).sort((row_a, row_b) => {
		const start_difference = getScheduleTimeSortValue(row_a.start_time) - getScheduleTimeSortValue(row_b.start_time);
		if(start_difference !== 0) return start_difference;

		const end_difference = getScheduleTimeSortValue(row_a.end_time) - getScheduleTimeSortValue(row_b.end_time);
		if(end_difference !== 0) return end_difference;

		return (row_a.period_order || 0) - (row_b.period_order || 0);
	});
}

const getLunchesForScheduleDay = (lunchInfo = {}, day) => {
	const lunches = lunchInfo?.lunches || {};
	const normalized_day = normalizeScheduleMatchID(day);

	return Object.keys(lunches).reduce((results, lunch_id) => {
		const lunch_info = lunches[lunch_id];
		if(!lunch_info) return results;

		const lunch_days = Array.isArray(lunch_info.days) ? lunch_info.days.map(normalizeScheduleMatchID) : [];
		if(!lunch_days.includes(normalized_day)) return results;
		if(!lunch_info.start_time || !lunch_info.end_time) return results;

		results.push({
			lunch_id: normalizeScheduleMatchID(lunch_id),
			start_time: lunch_info.start_time,
			end_time: lunch_info.end_time,
		});

		return results;
	}, []).sort((lunch_a, lunch_b) => getScheduleTimeSortValue(lunch_a.start_time) - getScheduleTimeSortValue(lunch_b.start_time));
}

const buildAcademicFullnessSlots = (schedule_rows = [], slot_prefix = 'academic') => {
	const slots = [];
	let current_slot = null;

	schedule_rows.forEach((schedule_row) => {
		if(!current_slot || !timesAreOverlapping(current_slot.start_time, current_slot.end_time, schedule_row.start_time, schedule_row.end_time))
		{
			current_slot = {
				type: 'academic',
				slot_id: `${slot_prefix}:${slots.length + 1}`,
				course_period_ids: [],
				start_time: schedule_row.start_time,
				end_time: schedule_row.end_time,
			};
			slots.push(current_slot);
		}

		if(!current_slot.course_period_ids.includes(schedule_row.course_period_id)) current_slot.course_period_ids.push(schedule_row.course_period_id);

		if(getScheduleTimeSortValue(schedule_row.start_time) < getScheduleTimeSortValue(current_slot.start_time)) current_slot.start_time = schedule_row.start_time;
		if(getScheduleTimeSortValue(schedule_row.end_time) > getScheduleTimeSortValue(current_slot.end_time)) current_slot.end_time = schedule_row.end_time;
	});

	return slots;
}

const buildFullnessPathCandidateFromLunchRows = (day, path_id, lunch_rows = [], schedule_rows = [], lunch_slot_id = path_id) => {
	const lunch_course_period_ids = lunch_rows.reduce((course_period_ids, lunch_row) => {
		if(!course_period_ids.includes(lunch_row.course_period_id)) course_period_ids.push(lunch_row.course_period_id);
		return course_period_ids;
	}, []);
	const lunch_course_period_id_set = new Set(lunch_course_period_ids.map(normalizeScheduleMatchID));
	const academic_rows = schedule_rows.filter(schedule_row => !lunch_course_period_id_set.has(normalizeScheduleMatchID(schedule_row.course_period_id)));
	const lunch_start_time = lunch_rows.reduce((start_time, lunch_row) => {
		return getScheduleTimeSortValue(lunch_row.start_time) < getScheduleTimeSortValue(start_time) ? lunch_row.start_time : start_time;
	}, lunch_rows[0]?.start_time);
	const lunch_end_time = lunch_rows.reduce((end_time, lunch_row) => {
		return getScheduleTimeSortValue(lunch_row.end_time) > getScheduleTimeSortValue(end_time) ? lunch_row.end_time : end_time;
	}, lunch_rows[0]?.end_time);

	return {
		day: normalizeScheduleMatchID(day),
		path_id,
		slots: [
			...buildAcademicFullnessSlots(academic_rows),
			{
				type: 'lunch',
				slot_id: lunch_slot_id,
				course_period_ids: lunch_course_period_ids,
				start_time: lunch_start_time,
				end_time: lunch_end_time,
			},
		].sort((slot_a, slot_b) => getScheduleTimeSortValue(slot_a.start_time) - getScheduleTimeSortValue(slot_b.start_time)),
	};
}

const buildStudentFullnessPathCandidatesForDay = (scheduleStructureData = {}, lunchInfo = {}, schedule_type = null, day) => {
	const schedule_rows = getPreparedScheduleRowsForDay(scheduleStructureData, day);
	if(schedule_rows.length === 0) return [];

	const should_use_lunch_paths = STUDENT_FULLNESS_PATH_SCHEDULE_TYPES.has(schedule_type);
	if(!should_use_lunch_paths)
	{
		return [{
			day: normalizeScheduleMatchID(day),
			path_id: `${day}:default`,
			slots: buildAcademicFullnessSlots(schedule_rows),
		}];
	}

	const lunches_for_day = getLunchesForScheduleDay(lunchInfo, day);
	const lunch_path_candidates = lunches_for_day.reduce((results, lunch_info) => {
		const lunch_rows = schedule_rows.filter(schedule_row => timesAreOverlapping(lunch_info.start_time, lunch_info.end_time, schedule_row.start_time, schedule_row.end_time));
		if(lunch_rows.length === 0) return results;

		results.push({
			...buildFullnessPathCandidateFromLunchRows(day, `${day}:lunch:${lunch_info.lunch_id}`, lunch_rows, schedule_rows, `lunch:${lunch_info.lunch_id}`),
			lunch_id: lunch_info.lunch_id,
		});

		return results;
	}, []);

	if(lunch_path_candidates.length > 0) return lunch_path_candidates;

	return [{
		day: normalizeScheduleMatchID(day),
		path_id: `${day}:default`,
		slots: buildAcademicFullnessSlots(schedule_rows),
	}];
}

const sectionHasCoursePeriodInSlot = (section_info = {}, course_period_ids = []) => {
	if(!Array.isArray(section_info.course_periods) || section_info.course_periods.length === 0) return false;
	const slot_course_period_ids = new Set(course_period_ids.map(normalizeScheduleMatchID));
	return section_info.course_periods.some(course_period_id => slot_course_period_ids.has(normalizeScheduleMatchID(course_period_id)));
}

const sectionIsActiveForFullnessUnit = (section_info = {}, quarter, day) => {
	const quarter_days = Array.isArray(section_info.quarter_days) ? section_info.quarter_days : [];
	const normalized_quarter = normalizeScheduleMatchID(quarter);
	const normalized_day = normalizeScheduleMatchID(day);
	const section_is_lab = section_info.is_lab === '1';

	return quarter_days.some(quarter_day => {
		if(normalizeScheduleMatchID(quarter_day?.quarter) !== normalized_quarter) return false;
		if(section_is_lab && normalizeScheduleMatchID(quarter_day?.day) !== normalized_day) return false;
		return true;
	});
}

const sectionIsLunchForFullness = (section_info = {}, courses_by_id = {}) => {
	const course_info = courses_by_id[normalizeScheduleMatchID(section_info.course_id)];
	return normalizeScheduleMatchID(course_info?.is_lunch) === '1';
}

const buildStudentInferredLunchPathCandidatesForDay = (scheduleStructureData = {}, studentSections = [], courses_by_id = {}, day) => {
	const schedule_rows = getPreparedScheduleRowsForDay(scheduleStructureData, day);
	if(schedule_rows.length === 0) return [];

	const inferred_lunch_course_period_groups = studentSections.reduce((results, section_info) => {
		if(!sectionIsLunchForFullness(section_info, courses_by_id)) return results;
		const section_is_active_for_day = STUDENT_FULLNESS_QUARTERS.some(quarter => sectionIsActiveForFullnessUnit(section_info, quarter, day));
		if(!section_is_active_for_day) return results;

		const lunch_course_period_ids = Array.isArray(section_info.course_periods) ? section_info.course_periods.map(normalizeScheduleMatchID).filter(Boolean) : [];
		if(lunch_course_period_ids.length === 0) return results;

		const group_key = lunch_course_period_ids.sort().join('|');
		results[group_key] = lunch_course_period_ids;
		return results;
	}, {});

	return Object.keys(inferred_lunch_course_period_groups).reduce((results, group_key) => {
		const lunch_course_period_ids = inferred_lunch_course_period_groups[group_key];
		const lunch_rows = schedule_rows.filter(schedule_row => lunch_course_period_ids.includes(normalizeScheduleMatchID(schedule_row.course_period_id)));
		if(lunch_rows.length === 0) return results;

		results.push(buildFullnessPathCandidateFromLunchRows(day, `${day}:student-lunch:${group_key}`, lunch_rows, schedule_rows, `student-lunch:${group_key}`));
		return results;
	}, []);
}

const evaluateStudentFullnessPathCandidate = (path_candidate = {}, student_sections = [], courses_by_id = {}) => {
	const required_unit_keys = new Set();
	const matched_unit_keys = new Set();
	const day = normalizeScheduleMatchID(path_candidate.day);
	let lunch_matched_units = 0;
	let academic_matched_units = 0;

	(path_candidate.slots || []).forEach((slot_info, slot_index) => {
		STUDENT_FULLNESS_QUARTERS.forEach((quarter) => {
			const unit_key = `${day}|${slot_info.slot_id || slot_index}|${quarter}`;
			required_unit_keys.add(unit_key);

			const slot_is_lunch = slot_info.type === 'lunch';
			const slot_matched = student_sections.some(section_info => {
				const section_is_lunch = sectionIsLunchForFullness(section_info, courses_by_id);
				if(slot_is_lunch !== section_is_lunch) return false;
				if(!sectionHasCoursePeriodInSlot(section_info, slot_info.course_period_ids)) return false;
				return sectionIsActiveForFullnessUnit(section_info, quarter, day);
			});

			if(!slot_matched) return;

			matched_unit_keys.add(unit_key);
			if(slot_is_lunch) lunch_matched_units++;
			else academic_matched_units++;
		});
	});

	return {
		path_candidate,
		required_units: required_unit_keys.size,
		matched_units: matched_unit_keys.size,
		lunch_matched_units,
		academic_matched_units,
	};
}

export function calculateStudentScheduleFullness({ scheduleInfo = {}, scheduleStructureData = {}, lunchInfo = {}, studentSections = [], courses = [] } = {}) {
	const schedule_type = scheduleInfo?.schedule_type || null;
	const schedule_structure = scheduleStructureData?.schedule_structure || {};
	const courses_by_id = getCourseLookupByID(courses);

	return getScheduleStructureDayKeys(schedule_structure).reduce((results, day) => {
		const path_candidates = [
			...buildStudentFullnessPathCandidatesForDay(scheduleStructureData, lunchInfo, schedule_type, day),
			...buildStudentInferredLunchPathCandidatesForDay(scheduleStructureData, studentSections, courses_by_id, day),
		];
		if(path_candidates.length === 0) return results;

		const best_path_result = path_candidates.reduce((best_result, path_candidate) => {
			const path_result = evaluateStudentFullnessPathCandidate(path_candidate, studentSections, courses_by_id);
			if(!best_result) return path_result;
			if(path_result.lunch_matched_units !== best_result.lunch_matched_units) return path_result.lunch_matched_units > best_result.lunch_matched_units ? path_result : best_result;
			if(path_result.academic_matched_units !== best_result.academic_matched_units) return path_result.academic_matched_units > best_result.academic_matched_units ? path_result : best_result;
			if(path_result.matched_units !== best_result.matched_units) return path_result.matched_units > best_result.matched_units ? path_result : best_result;
			return path_result.required_units > best_result.required_units ? path_result : best_result;
		}, null);

		if(!best_path_result) return results;

		results.required_units += best_path_result.required_units;
		results.matched_units += best_path_result.matched_units;
		results.selected_paths.push(best_path_result.path_candidate);

		return results;
	}, {
		required_units: 0,
		matched_units: 0,
		selected_paths: [],
	});
}

export function calculateStudentMatchPercent(num_student_requests = 0, total_credits = 0, matched_requests = 0, total_quarters = 0, matched_quarters = 0) {
	const student_match_percent = (num_student_requests === 0) ? 0 : Math.min(Math.round(matched_requests/num_student_requests * 100), 100);
	const student_percent_schedule_full = (total_quarters !== 0) ? Math.min(Math.round(matched_quarters/total_quarters * 100), 100) : 0;
	return {
		student_match_percent,
		student_percent_schedule_full
	}
}

export function getStudentScheduleStatus(student_match_percent = 0, student_percent_schedule_full = 0) {
	if(student_percent_schedule_full === 0) return 'empty';
	if(student_match_percent >= 100 || student_percent_schedule_full >= 100) return 'full';
	return 'partial';
}

/*export function closeModal(modalToClose)
{
	// GENERAL CLOSING AND CLEARING OF ATTRIBUTES
	// Close it first, then do all necessary functions
	$("#close-without-saving-modal").fadeOut();
	// Run any passed function
	var referredData = $("#" + modalToClose).attr("data-referreddata");
	
	if(referredData && referredData !== '') eval(referredData);
		
	$("#" + modalToClose).fadeOut(function(){
		$("#close-without-saving-modal").attr('data-modaltoclose', "");
		
		// Clear any data attributes on the modal
		$.each($("#" + modalToClose).data(), function (i) {
		    $("#" + modalToClose).attr("data-" + i, "");
		});
		
		// SPECIAL screenES FOR CERTAIN MODALS
		if(modalToClose == "section-details-modal")
		{
			var delay_schedule_update = sessionStorage.getItem("delay_schedule_update");
			
			if(delay_schedule_update == 1)
			{
				sessionStorage.setItem("delay_schedule_update", 0);
				
				updateMatchPercentages();
			}
		}
	});
}*/

export function sortObject(passedJSONObject, sortBy, sortType = 'number')
{
	if(Object.keys(passedJSONObject).length === 0) return [];
	
	var sorted_object = Object.keys(passedJSONObject).sort(function(a,b){
		var compA, compB;
		
		if(sortBy)
		{
			const valueA = passedJSONObject[a][sortBy];
			const valueB = passedJSONObject[b][sortBy];

			compA = (!valueA) ? null : ((sortType === 'number') ? parseInt(valueA) : valueA.toString().toLowerCase());
			compB = (!valueB) ? null : ((sortType === 'number') ? parseInt(valueB) : valueB.toString().toLowerCase());
			
			return (compA === null) - (compB === null) || +(compA > compB) || -(compA < compB);
		} else
		{
			const valueA = passedJSONObject[a];
			const valueB = passedJSONObject[b];

			compA = (!valueA) ? null : ((sortType === 'number') ? parseInt(valueA) : valueA.toString().toLowerCase());
			compB = (!valueB) ? null : ((sortType === 'number') ? parseInt(valueB) : valueB.toString().toLowerCase());
			
			return (compA === null) - (compB === null) || +(compA > compB) || -(compA < compB);
		}
		
	}).map(key => passedJSONObject[key]);
	
	return sorted_object;
}

export function reverseSortObject(passedJSONObject, sortBy, sortType = 'number')
{
	if(Object.keys(passedJSONObject).length === 0) return [];
	
	var sorted_object = Object.keys(passedJSONObject).sort(function(a,b){
		var compA = (sortType === 'number') ? parseInt(passedJSONObject[a][sortBy]) : passedJSONObject[a][sortBy].toString().toLowerCase();
		var compB = (sortType === 'number') ? parseInt(passedJSONObject[b][sortBy]) : passedJSONObject[b][sortBy].toString().toLowerCase();
		
		return (compB === null) - (compA === null) || +(compB > compA) || -(compB < compA);
	}).map(key => passedJSONObject[key]);
	
	return sorted_object;
}

export function sortArrayOfObjects(passedArray, sortKey, sortType, AscDesc)
{
	if(passedArray.length === 0) return [];

	const naturalSortCompare = (valueA, valueB) => {
		const normalized_a = `${valueA ?? ''}`;
		const normalized_b = `${valueB ?? ''}`;
		return normalized_a.localeCompare(normalized_b, undefined, {numeric: true, sensitivity: 'base'});
	};
	
	passedArray.sort((compA, compB) => {
		const valA = compA[sortKey];
		const valB = compB[sortKey];

		if(sortType === 'natural')
		{
			const comparison = naturalSortCompare(valA, valB);
			if(AscDesc === 'desc') return comparison * -1;
			return comparison;
		}
		
		const compValA = (!valA) ? null : ((sortType === 'number') ? parseInt(valA) : valA.toString().toLowerCase());
		const compValB = (!valB) ? null : ((sortType === 'number') ? parseInt(valB) : valB.toString().toLowerCase());
		
		if(AscDesc === 'asc')
		{
			if(!compValA || compValA > compValB) return 1;
			if(!compValB || compValA < compValB) return -1;
		}
		else
		{
			if(!compValA || compValA > compValB) return -1;
			if(!compValB || compValA < compValB) return 1;
		}
			
		return 0;
	});
	
	return passedArray;
}

export function naturalSortCompare(valueA, valueB)
{
	return `${valueA ?? ''}`.localeCompare(`${valueB ?? ''}`, undefined, {numeric: true, sensitivity: 'base'});
}

export function compareValues(key, order = 'asc') {
	return function innerSort(a, b) {
		if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) return 0;
		
		const varA = (typeof a[key] === 'string') ? a[key].toUpperCase() : a[key];
		const varB = (typeof b[key] === 'string') ? b[key].toUpperCase() : b[key];
		
		let comparison = 0;
		
		if(varA > varB) {
			comparison = 1;
		} 
		else if (varA < varB) {
			comparison = -1;
		}
		
		return ((order === 'desc') ? (comparison * -1) : comparison);
	};
}

export function getSubsetOfObject(originalObj, keysToKeepArray)
{
	const newObject = {};
    keysToKeepArray.forEach(key => { newObject[key] = originalObj[key]; });
    return newObject;
}

export function filterArrayOfObjects(passedArray, searchValue, possibleKeys)
{
	const normalizeForSearch = (value) => {
		return `${value ?? ''}`
			.toLowerCase()
			.replace(/[^a-z0-9]+/g, ' ')
			.trim()
			.replace(/\s+/g, ' ');
	};

	const normalized_search_value = normalizeForSearch(searchValue);
	if(!normalized_search_value) return passedArray;

	const search_tokens = normalized_search_value.split(' ');

	return passedArray.filter((data) => {
		const combined_possible_values = possibleKeys.reduce((results, key) => {
			if(!(key in data) || data[key] === null || data[key] === undefined) return results;
			results.push(`${data[key]}`);
			return results;
		}, []).join(' ');

		const normalized_data_value = normalizeForSearch(combined_possible_values);
		if(!normalized_data_value) return false;

		if(normalized_data_value.includes(normalized_search_value)) return true;
		return search_tokens.every(search_token => normalized_data_value.includes(search_token));
	});
}

/*export function sortDivs(divsToSort, sortAttribute, divToAddTo, ascDesc, dataType)
{
	var divList = $(divsToSort);
	
	if(ascDesc == "asc")
	{
		if(dataType == "text")
		{
			divList.sort(function(a, b){
			    return ($(a).attr(sortAttribute).toLowerCase() > $(b).attr(sortAttribute).toLowerCase()) ? 1 : -1;
			});
		}
		else if(dataType == "number")
		{
			divList.sort(function(a, b){
			    return (parseInt($(a).attr(sortAttribute)) > parseInt($(b).attr(sortAttribute))) ? 1 : -1;
			});
		}
		
	}
	else
	{
		if(dataType == "text")
		{
			divList.sort(function(a, b){
			    return ($(a).attr(sortAttribute).toLowerCase() < $(b).attr(sortAttribute).toLowerCase()) ? 1 : -1;
			});
		}
		else if(dataType == "number")
		{
			divList.sort(function(a, b){
			    return (parseInt($(a).attr(sortAttribute)) < parseInt($(b).attr(sortAttribute))) ? 1 : -1;
			});
		}
	}
	
	$(divToAddTo).html(divList);
}*/

/*export function filterDivs(filter, divsToFilter, filterAttributes)
{	
	var filter = filter.toLowerCase();
	var filterAttributes = JSON.parse(filterAttributes);
	
	$(divsToFilter).hide();
	
	$(divsToFilter).each(function(){
		var $this = $(this);
		
		$.each(filterAttributes, function(index, attr){
			var divVal = $this.attr(attr).toLowerCase();
			
			if(divVal.indexOf(filter) > -1)
			{
				$this.show();
			}
		});
	});
}*/

export function createNewKeyForObject(obj) {
	return (isEmpty(obj)) ? "1" : (parseInt(Object.keys(obj).reduce(function(a, b){return parseInt(a,10) > parseInt(b,10) ? a : b})) + 1).toString();
}

export function cloneObj(obj) {
	return JSON.parse(JSON.stringify(obj));
}

Object.filter = (obj, predicate) => 
    Object.keys(obj)
          .filter( key => predicate(obj[key]) )
          .reduce( (res, key) => Object.assign(res, { [key]: obj[key] }), {} );


export function convertObjectToArray(obj) {
	let dataArray = [];

	for(const key in obj)
	{
		dataArray.push(obj[key]);
	}
	
	return dataArray;
}

export function arraysEqual(_arr1, _arr2)
{
    if (!Array.isArray(_arr1) || ! Array.isArray(_arr2) || _arr1.length !== _arr2.length) return false;

    var arr1 = _arr1.concat().sort();
    var arr2 = _arr2.concat().sort();

    for(var i = 0; i < arr1.length; i++)
    {
        if (arr1[i] !== arr2[i]) return false;
    }

    return true;
}

export function areArraysOrObjectsEqual(value, other) {

	// Get the value type
	var type = Object.prototype.toString.call(value);

	// If the two objects are not the same type, return false
	if (type !== Object.prototype.toString.call(other)) return false;

	// If items are not an object or array, return false
	if (['[object Array]', '[object Object]'].indexOf(type) < 0) return false;

	// Compare the length of the length of the two items
	var valueLen = type === '[object Array]' ? value.length : Object.keys(value).length;
	var otherLen = type === '[object Array]' ? other.length : Object.keys(other).length;
	if (valueLen !== otherLen) return false;

	// Compare two items
	var compare = function (item1, item2) {

		// Get the object type
		var itemType = Object.prototype.toString.call(item1);

		// If an object or array, compare recursively
		if (['[object Array]', '[object Object]'].indexOf(itemType) >= 0) {
			if (!areArraysOrObjectsEqual(item1, item2)) return false;
		}

		// Otherwise, do a simple comparison
		else {

			// If the two items are not the same type, return false
			if (itemType !== Object.prototype.toString.call(item2)) return false;

			// Else if it's a function, convert to a string and compare
			// Otherwise, just compare
			if (itemType === '[object Function]') {
				if (item1.toString() !== item2.toString()) return false;
			} else {
				if (item1 !== item2) return false;
			}

		}
	};

	// Compare properties
	if (type === '[object Array]') {
		for (var i = 0; i < valueLen; i++) {
			if (compare(value[i], other[i]) === false) return false;
		}
	} else {
		for (var key in value) {
			if (value.hasOwnProperty(key)) {
				if (compare(value[key], other[key]) === false) return false;
			}
		}
	}

	// If nothing failed, return true
	return true;

};

export function findDeletedValues(arr1, arr2, passing_object = false, key_to_check = null)
{
	if(passing_object)
	{
		return arr1.filter(x => !arr2.some(y => x[key_to_check] === y[key_to_check]));
	}
	else
	{
		return arr1.filter(x => !arr2.includes(x));
	}
}

export function findAddedValues(arr1, arr2, passing_object = false, key_to_check = null)
{
	if(passing_object)
	{
		return arr2.filter(x => !arr1.some(y => x[key_to_check] === y[key_to_check]));
	}
	else
	{
		return arr2.filter(x => !arr1.includes(x));
	}
}

export function findIntersection(arr1, arr2, passing_object = false, key_to_check = null)
{
	if(passing_object)
	{
		return arr1.filter(x => arr2.some(y => x[key_to_check] === y[key_to_check]));
	}
	else
	{
		return arr1.filter(x => arr2.includes(x));
	}
}

export function overlapCheck(time1, time2) {
	const start_time1 = time1.start_time;
	const end_time1 = time1.end_time;
	const start_time1_array = start_time1.split(':');
	const end_time1_array = end_time1.split(':');

	const start_time1_number = parseInt(start_time1_array[0] + start_time1_array[1]);
	const end_time1_number = parseInt(end_time1_array[0] + end_time1_array[1]);

	const start_time2 = time2.start_time;
	const end_time2 = time2.end_time;
	const start_time2_array = start_time2.split(':');
	const end_time2_array = end_time2.split(':');

	const start_time2_number = parseInt(start_time2_array[0] + start_time2_array[1]);
	const end_time2_number = parseInt(end_time2_array[0] + end_time2_array[1]);

	if(end_time1_number > start_time2_number && end_time2_number > start_time1_number) return true;

	return false;
}

export function createMatrix(m, n) {
	if(!m || !n) return [];
	
	var matrix = [];
	
	for(var i=0; i < m; i++)
	{
		matrix[i] = [];
		for(var j=0; j<n; j++)
		{
			matrix[i][j] = 0;
		}
	}
	
	return matrix;
};

export const useOutsideClick = (ref, callback, array_of_class_name_exclusions = []) => {
	const handleClick = e => {
		const target_contains_exclusion = array_of_class_name_exclusions.reduce((results, class_name) => {
			if(e.target.classList.contains(class_name) || (e.target.closest('.parent-div') && e.target.closest('.parent-div').classList.contains(class_name))) results = true;
			return results;
		}, false);
		
		if(ref.current && !ref.current.contains(e.target) && !ref.current.classList.contains('click-restricted') && !e.target.classList.contains('click-restricted') && (!e.target.closest('.parent-div') || (e.target.closest('.parent-div') && !e.target.closest('.parent-div').classList.contains('click-restricted'))) && !target_contains_exclusion) {
			callback();
			return;
		}
	};
		
	useEffect(() => {
		document.addEventListener("click", handleClick);
		
		return () => {
			document.removeEventListener("click", handleClick);
		};
	});
};

export const useDebouncedValue = (value, delay = 120) => {
	const [debouncedValue, setDebouncedValue] = useState(value);

	useEffect(() => {
		const timeoutId = setTimeout(() => {
			setDebouncedValue(value);
		}, delay);

		return () => clearTimeout(timeoutId);
	}, [value, delay]);

	return debouncedValue;
}

export const getNextSchedulePeriod = (scheduleStructureData, current_day, starting_schedule_period_id, excluded_scheduled_period_ids = []) => {
	const availability_matrix = scheduleStructureData.availability_matrix;
	const all_schedule_periods = sortArrayOfObjects(scheduleStructureData.schedule_structure[current_day], 'period_order');
			
	// get the schedule periods that are not allowed during the current schedule period
	const unallowed_schedule_periods = availability_matrix[starting_schedule_period_id].concat(excluded_scheduled_period_ids);
	
	// get the index of the current schedule period (so we don't check any schedule periods before it
	const starting_schedule_period_index = all_schedule_periods.findIndex(schedule_period => schedule_period.period_id === starting_schedule_period_id);
	
	// Find next schedule period by traversing all schedule periods after the current, and finding the first one that is not in the unallowed list
	for(let i = starting_schedule_period_index + 1; i < all_schedule_periods.length;i++)
	{
		const current_schedule_period_id = all_schedule_periods[i].period_id;
	
		if(!unallowed_schedule_periods.includes(current_schedule_period_id)) return current_schedule_period_id;
	}
	
	return false;
}

export const getPreviousSchedulePeriod = (scheduleStructureData, current_day, starting_schedule_period_id, excluded_scheduled_period_ids = []) => {
	const availability_matrix = scheduleStructureData.availability_matrix;
	const all_schedule_periods = sortArrayOfObjects(scheduleStructureData.schedule_structure[current_day], 'period_order');
			
	// get the schedule periods that are not allowed during the current schedule period
	const unallowed_schedule_periods = availability_matrix[starting_schedule_period_id].concat(excluded_scheduled_period_ids);

	// get the index of the current schedule period (so we don't check any schedule periods before it
	const starting_schedule_period_index = all_schedule_periods.findIndex(schedule_period => schedule_period.period_id === starting_schedule_period_id);

	// Find previous schedule period by traversing all schedule periods before the current, and finding the first one that is not in the unallowed list
	for (let i = starting_schedule_period_index - 1; i >= 0; i--)
	{
		var current_schedule_period_id = all_schedule_periods[i].period_id;
		
		if(!unallowed_schedule_periods.includes(current_schedule_period_id)) return current_schedule_period_id;
	}
	
	return false;
}

export const getNextCoursePeriod = (scheduleStructureData, starting_course_period_id) => {
	const course_periods = scheduleStructureData.course_periods;
	const all_course_periods = Object.keys(course_periods).sort();
	
	// get the index of the current schedule period (so we don't check any schedule periods before it
	var starting_course_period_index = all_course_periods.indexOf(starting_course_period_id);
	
	var next_course_period_id = all_course_periods[starting_course_period_index + 1];
	
	if(!next_course_period_id) return false;
	
	return next_course_period_id;
}

export const getPreviousCoursePeriod = (scheduleStructureData, starting_course_period_id) => {
	const course_periods = scheduleStructureData.course_periods;
	const all_course_periods = Object.keys(course_periods).sort();
	
	// get the index of the current schedule period (so we don't check any schedule periods before it
	var starting_course_period_index = all_course_periods.indexOf(starting_course_period_id);
	
	var previous_course_period_id = all_course_periods[starting_course_period_index - 1];
	
	if(!previous_course_period_id) return false;
	
	return previous_course_period_id;
}

export const coursePeriodToSchedulePeriod = (scheduleStructureData, course_period_id, day) => {
	const course_periods = scheduleStructureData.course_periods;
	const schedule_period_id = course_periods[course_period_id]['days'][day];
	
	return schedule_period_id;
}

export const schedulePeriodToCoursePeriod = (scheduleStructureData, schedule_period_id, day) => {
	const schedule_structure = scheduleStructureData.schedule_structure;
	const course_period_id = schedule_structure[day][schedule_period_id];
	
	return course_period_id;
}

export const calculateAffectedSectionsForPlacements = (passed_data) => {
	const { sections, subsections, section_id, new_course_period_id, old_course_period_id } = passed_data;

	const section_index = sections.findIndex(section => section.section_id === section_id);
	const section_info = sections[section_index];

	let affected_sections = [];

	// Add dragged section as affected section
	affected_sections.push({section_id:section_id, new_course_period_id:new_course_period_id, old_course_period_id:old_course_period_id, edit_teacher:true});
	
	// Check if dragged is subsection 
	const subsection_index = subsections.findIndex(subsection => subsection.subsection_id === section_id);

	// If dragged is not subsection, collect subsections and update them too
	// If dragged is subsection, collect main section AND all other subsections and update them too
	if(subsection_index === -1)
	{
		const section_subsections = section_info.subsections;

		if(section_subsections.length > 0)
		{
			section_subsections.forEach(subsection_id => {
				affected_sections.push({section_id:subsection_id, new_course_period_id:new_course_period_id, old_course_period_id, edit_teacher:false});
			});
		}
	}
	else
	{
		const subsection_info = subsections[subsection_index];

		// Get main section info
		const main_section_id = subsection_info.section_id;
		const main_section_info = sections.find(section => section.section_id === main_section_id);

		// Add main section as affected section
		affected_sections.push({section_id:main_section_id, new_course_period_id:new_course_period_id, old_course_period_id, edit_teacher:false});

		// Add other subsections of the main section as affected sections too
		if(main_section_info.subsections.length > 0)
		{
			main_section_info.subsections.forEach(other_subsection_id => {
				if(other_subsection_id !== section_id) affected_sections.push({section_id:other_subsection_id, new_course_period_id:new_course_period_id, old_course_period_id:old_course_period_id, edit_teacher:false});
			});
		}
	}

	return affected_sections;
}

export const verifyUser = async (data) => {
	const apiName = process.env.REACT_APP_ENDPOINT_NAME;
	const url = '/verify-user';
    const myInit = { // OPTIONAL
        response: true,
        body: JSON.stringify(data),
    };
    
    await API.post(apiName, url, myInit);
    
   	return;
}

export const copyPreviousYearData = async (data, _callback = () => {}) => {
	// data includes school_id, selected_schedule_year_id, courses_checked, teachers_checked, classrooms_checked, students_checked
	const apiName = process.env.REACT_APP_ENDPOINT_NAME;
	const url = '/copy-previous-year-data';
	const myInit = { // OPTIONAL
		response: true,
		body: JSON.stringify(data),
	};
	
	await API.post(apiName, url, myInit);

	return;
}

export const switchCurrentYear = async (data, _callback = () => {}) => {
	// data includes school_id, selected_schedule_year_id

	const apiName = process.env.REACT_APP_ENDPOINT_NAME;
	const url = '/switch-current-year';
	const myInit = { // OPTIONAL
		response: true,
		body: JSON.stringify(data),
	};
	
	await API.post(apiName, url, myInit);

	_callback();
}

export const getCurrentSubscreen = async (data, _callback = () => {}) => {
	const apiName = process.env.REACT_APP_ENDPOINT_NAME;
	const url = '/get-current-subscreen';
    const myInit = { // OPTIONAL
        response: true,
        body: JSON.stringify(data),
    };
    
    const response = await API.post(apiName, url, myInit);
    const result = response.data;
    
    _callback(result);
}

export const getDepartmentProgress = async (passed_data) => {
	const school_id = ('school_id' in passed_data) ? passed_data.school_id : null;
	const schedule_version_id = ('schedule_version_id' in passed_data) ? passed_data.schedule_version_id : null;
	const subscreen = ('subscreen' in passed_data) ? passed_data.subscreen : null;

	
	const apiName = process.env.REACT_APP_ENDPOINT_NAME;
	const url = '/get-department-progress';
    const myInit = { // OPTIONAL
        response: true,
        queryStringParameters: {school_id:school_id, subscreen:subscreen, schedule_version_id:schedule_version_id},
    };
    
    let data;
    
	try {
		const response = await API.get(apiName, url, myInit);
		data = response.data;
	} catch(e)
	{
		console.log(e.response);
	}
	
	return data;
}
	
export const checkPermissions = async (passed_data) => {
	const school_id = passed_data.school_id;
	const subscreen = passed_data.subscreen;
	const schedule_version_id = passed_data.schedule_version_id;
	const database = ('database' in passed_data) ? passed_data.database : 'edario';
	const _callback = ('callback' in passed_data) ? passed_data.callback : ()=>{};
	const forceLock = ('forceLock' in passed_data) ? passed_data.forceLock : false;

	let result= {};
	
	if(!forceLock)
	{
		const apiName = process.env.REACT_APP_ENDPOINT_NAME;
		const url = '/check-screen-permissions';
		const data = {school_id: school_id, schedule_version_id:schedule_version_id, selected_subscreen:subscreen, database:database};
	    const myInit = { // OPTIONAL
	        response: true,
	        body: JSON.stringify(data),
	    };
	    
	    const response = await API.post(apiName, url, myInit);
	    result = response.data;
	}
	else
	{
		result.permissions = 'locked';
	}
	
	_callback(result);
}

export const getSchoolRunningProcesses = async (passed_data) => {
	const school_id = passed_data.school_id;
	const schedule_year_id = passed_data.schedule_year_id;

	// Process Types:
	//course data = 1
	//previous section data = 2
	//student requests = 3
	//students = 4
	// predict sections = 5 
	//sectionplace = 6
	//studentplace = 7
	const apiName = process.env.REACT_APP_ENDPOINT_NAME;
	const url = '/process/check-progress';
	const myInit = {
        response: true,
        queryStringParameters: { 
          school_id: school_id, 
		  schedule_year_id: schedule_year_id
        }
    };
	
	const response = await API.get(apiName, url, myInit);
	const result = response.data;
	
	return result;
}

export const clearSectionPlacement = async ({school_id, schedule_version_id}) => {
	const apiName = process.env.REACT_APP_ENDPOINT_NAME;
	const url = '/clear-sections';
	const myInit = {
		response: true,
		body: JSON.stringify({school_id, schedule_version_id}),
	};

	const response = await API.post(apiName, url, myInit);
	return response.data;
}

export const runSectionPlacement = async ({school_id, schedule_version_id, data_version_id}) => {
	const apiName = process.env.REACT_APP_ENDPOINT_NAME;
	const url = '/place-sections';
	const myInit = {
		response: true,
		queryStringParameters: {school_id, schedule_version_id, data_version_id},
	};

	const response = await API.get(apiName, url, myInit);
	return response.data;
}

export const runClassroomPlacement = async ({school_id, schedule_version_id}) => {
	const apiName = process.env.REACT_APP_ENDPOINT_NAME;
	const url = '/place-classrooms';
	const myInit = {
		response: true,
		body: JSON.stringify({school_id, schedule_version_id}),
	};

	const response = await API.post(apiName, url, myInit);
	return response.data;
}

export const runStudentPlacement = async ({school_id, schedule_version_id, data_version_id}) => {
	const apiName = process.env.REACT_APP_ENDPOINT_NAME;
	const url = '/place-students';
	const myInit = {
		response: true,
		queryStringParameters: {school_id, schedule_version_id, data_version_id},
	};

	const response = await API.get(apiName, url, myInit);
	return response.data;
}

export const checkProcessProgress = async (data) => {
	const school_id = data.school_id;
	const progress_id = data.progress_id;

	// Process Types:
	//course data = 1
	//previous section data = 2
	//student requests = 3
	//students = 4
	// predict sections = 5 
	//sectionplace = 6
	//studentplace = 7
	const apiName = process.env.REACT_APP_ENDPOINT_NAME;
	const url = '/process/check-progress';
	const myInit = {
        response: true,
        queryStringParameters: { 
          school_id: school_id, 
		  progress_id: progress_id
        }
    };
	
	const response = await API.get(apiName, url, myInit);
	const result = response.data;
	
	return result;
}

export const getProcessFeedback = async (data) => {
	const school_id = data.school_id;
	const progress_id = data.progress_id;
	const data_version_id = data.data_version_id;
	const process_type = data.process_type;
	const department_id = ('department_id' in data) ? data.department_id : null;

	// Process Types:
	//course data = 1
	//previous section data = 2
	//student requests = 3
	//students = 4
	// predict sections = 5 
	//sectionplace = 6
	//studentplace = 7

	const apiName = process.env.REACT_APP_ENDPOINT_NAME;
	const url = '/process/get-feedback';
	const myInit = {
        response: true,
        queryStringParameters: { 
          school_id: school_id, 
		  progress_id: progress_id,
		  data_version_id: data_version_id,
          process_type: process_type, 
		  ...department_id && ({department_id}),
        }
    };
	
	const response = await API.get(apiName, url, myInit);
	const result = response.data;
	
	return result;
}

export const clearProcessFeedback = async (data) => {
	const school_id = data.school_id;
	const progress_id = data.progress_id;
	const data_version_id = data.data_version_id;
	const process_type = data.process_type;
	const department_id = ('department_id' in data) ? data.department_id : null;

	// Process Types:
	//course data = 1
	//previous section data = 2
	//student requests = 3
	//students = 4
	// predict sections = 5 
	//sectionplace = 6
	//studentplace = 7

	const apiName = process.env.REACT_APP_ENDPOINT_NAME;
	const url = '/process/clear-feedback';
	const myInit = {
        response: true,
        queryStringParameters: { 
          school_id: school_id, 
		  progress_id: progress_id,
		  data_version_id: data_version_id,
          process_type: process_type, 
		  ...department_id && ({department_id}),
        }
    };
	
	const response = await API.del(apiName, url, myInit);
	const result = response.data;
	
	return result;
}

export const continueProcess = async (data) => {
	// Process Types:
	//course data = 1
	//previous section data = 2
	//student requests = 3
	//students = 4
	// predict sections = 5 
	//sectionplace = 6
	//studentplace = 7

	const apiName = process.env.REACT_APP_ENDPOINT_NAME;
	const url = '/process/continue';
	const myInit = { // OPTIONAL
        response: true,
        body: JSON.stringify(data),
    };
	
	const response = await API.post(apiName, url, myInit);
	const result = response.data;
	
	return result;
}

export const getData = async (dataName, url, params = {}, forceNew = false, database = 'edario') => {
	const apiName = (database === 'edario') ? process.env.REACT_APP_ENDPOINT_NAME : process.env.REACT_APP_ELEM_ENDPOINT_NAME;
	const normalized_params = {...params};
	const partial_refresh = normalized_params.partial_refresh === true;
	if(normalized_params.target_ids && typeof normalized_params.target_ids === 'object') normalized_params.target_ids = JSON.stringify(normalized_params.target_ids);
    const myInit = { // OPTIONAL
        response: true,
        queryStringParameters: normalized_params,
    };
    
    let data;
	const fallback_data = (dataName === 'sections') ? {sections:[], subsections:[], labels:[]} : ((dataName === 'blocks') ? [] : null);
    	
	if(!JSONexists(`${dataName}`) || forceNew)
	{
		try {
			const response = await API.get(apiName, url, myInit);
			data = response.data;
		} catch(e)
		{
			console.log(e.response);
		}
		
		//console.log(`GETTING [${dataName}] DATA FROM DATABASE`);
		//console.log(data);

		if(data === undefined || data === null) return fallback_data;
		
		if(!partial_refresh) localStorage.setItem(`${dataName}`, JSON.stringify(data));

		if(dataName === 'sections')
		{
			data.sections = (Array.isArray(data.sections)) ? data.sections : [];
			data.subsections = (Array.isArray(data.subsections)) ? data.subsections : [];
			data.labels = (Array.isArray(data.labels)) ? data.labels : [];

			const connections = await getSectionConnections(params.school_id, params.schedule_version_id, params.target_ids || null) || {};
			const section_course_periods = ('course_periods' in connections) ? connections.course_periods : {};
			const section_departments = ('departments' in connections) ? connections.departments : {};
			const section_quarter_days = ('quarter_days' in connections) ? connections.quarter_days : {};
			const section_student_list = ('student_list' in connections) ? connections.student_list : {};
			const section_subsections = ('subsections' in connections) ? connections.subsections : {};
			const section_labels = ('labels' in connections) ? connections.labels : {};
			const section_secondary_teachers = ('secondary_teachers' in connections) ? connections.secondary_teachers : {};
			let sections_with_connections = [];

			data.sections.forEach(specific_data => {
				const section_id = specific_data.section_id;

				const course_periods = (section_id in section_course_periods) ? section_course_periods[section_id] : [];
				const departments = (section_id in section_departments) ? section_departments[section_id] : [];
				const quarter_days = (section_id in section_quarter_days) ? section_quarter_days[section_id] : [];
				const student_list = (section_id in section_student_list) ? section_student_list[section_id] : [];
				const subsections = (section_id in section_subsections) ? section_subsections[section_id] : [];
				const labels = (section_id in section_labels) ? section_labels[section_id] : [];
				const secondary_teachers = (section_id in section_secondary_teachers) ? section_secondary_teachers[section_id] : [];
				
				specific_data.course_periods = course_periods;
				specific_data.departments = departments;
				specific_data.quarter_days = quarter_days;
				specific_data.raw_quarter_days = cloneObj(quarter_days);
				specific_data.student_list = student_list;
				specific_data.subsections = subsections;
				specific_data.labels = labels;
				specific_data.secondary_teachers = secondary_teachers;

				sections_with_connections.push(specific_data);
			});

			const sections_by_id = sections_with_connections.reduce((results, section_info) => {
				results[section_info.section_id] = section_info;
				return results;
			}, {});
			const subsection_parent_by_id = data.subsections.reduce((results, subsection_info) => {
				results[subsection_info.subsection_id] = subsection_info.section_id;
				return results;
			}, {});
			sections_with_connections = sections_with_connections.map(section_info => {
				const parent_section_id = subsection_parent_by_id[section_info.section_id];
				const parent_section_info = parent_section_id ? sections_by_id[parent_section_id] : null;
				const inherits_quarter_days = parent_section_info && `${section_info.has_separate_quarter_days || '1'}` !== '1';

				if(inherits_quarter_days)
				{
					section_info.quarter_days = cloneObj(parent_section_info.quarter_days || []);
					section_info.inherits_quarter_days = '1';
				}
				else
				{
					section_info.inherits_quarter_days = '0';
				}

				return section_info;
			});

			data.sections = sections_with_connections;
		}
		else if(dataName === 'blocks')
		{
			data = (Array.isArray(data)) ? data : [];
			const block_connections = await getBlockConnections(params.school_id, params.schedule_version_id) || {};
			const secondary_teachers_by_block = ('secondary_teachers' in block_connections) ? block_connections.secondary_teachers : {};
			const students_by_block = ('students_in_blocks' in block_connections) ? block_connections.students_in_blocks : {};
			let blocks_with_connections = [];

			data.forEach(specific_data => {
				const block_id = specific_data.block_id;

				const secondary_teachers = (block_id in secondary_teachers_by_block) ? secondary_teachers_by_block[block_id] : [];
				const student_list = (block_id in students_by_block) ? students_by_block[block_id] : [];

				specific_data.secondary_teachers = secondary_teachers;
				specific_data.student_list = student_list;

				blocks_with_connections.push(specific_data);
			});

			data = blocks_with_connections;
		}
	}
	else
	{
		const storageInfo = getJSONFromStorage(`${dataName}`, true);
		
		//console.log(`GETTING [${dataName}] DATA FROM STORAGE`);
		//console.log(storageInfo);
		data = (storageInfo === undefined || storageInfo === null) ? fallback_data : storageInfo;
	}
	
	return data;
}

export const getSectionConnections = async (school_id, schedule_version_id, target_ids = null) => {
	const apiName = process.env.REACT_APP_ENDPOINT_NAME;
	const queryStringParameters = {school_id: school_id, schedule_version_id:schedule_version_id};
	if(target_ids && typeof target_ids === 'object') queryStringParameters.target_ids = JSON.stringify(target_ids);

	const myInit = { // OPTIONAL
		response: true,
		queryStringParameters,
	};

	try {
		const response = await API.get(apiName, '/get-section-connections', myInit);
		const connections = response.data;

		return connections;
	} catch(e)
	{
		console.log(e.response);
	}
}

export const getBlockConnections = async (school_id, schedule_version_id) => {
	const apiName = process.env.REACT_APP_ELEM_ENDPOINT_NAME;
	const myInit = { // OPTIONAL
		response: true,
		queryStringParameters: {school_id: school_id, schedule_version_id:schedule_version_id},
	};

	try {
		const response = await API.get(apiName, '/elementary/get-block-connections', myInit);
		const connections = response.data;

		return connections;
	} catch(e)
	{
		console.log(e.response);
	}
}

export const loadDataConnections = async (passed_data) => {
	const dataTypes = passed_data.data_types;
	const dataTypesStringified = JSON.stringify(dataTypes);
	const scheduleVersionID = passed_data.schedule_version_id;
	const dataVersionID = passed_data.data_version_id;
	const schoolId = passed_data.school_id;
	const database = ('database' in passed_data) ? passed_data.database : 'edario';
	const targetIds = ('target_ids' in passed_data && passed_data.target_ids && typeof passed_data.target_ids === 'object') ? JSON.stringify(passed_data.target_ids) : null;
	
	const apiName = process.env.REACT_APP_ENDPOINT_NAME;
	const params = {school_id:schoolId, data_types:dataTypesStringified, data_version_id:dataVersionID, schedule_version_id:scheduleVersionID, database:database};
	if(targetIds) params.target_ids = targetIds;
    const myInit = { // OPTIONAL
        response: true,
        queryStringParameters: params,
    };
    
    let data;
    
    try {
		const response = await API.get(apiName, '/load-data-connections', myInit);
		data = response.data;
	} catch(e)
	{
		console.log(e.response);
	}
	
	return data;
}

export const loadData = async (passed_data) => {
	const dataTypes = Array.isArray(passed_data.data_types) ? [...passed_data.data_types] : [];
	const dataTypesStringified = JSON.stringify(dataTypes);
	const scheduleVersionID = passed_data.schedule_version_id;
	const dataVersionID = passed_data.data_version_id;
	const schoolId = passed_data.school_id;
	const database = ('database' in passed_data) ? passed_data.database : 'edario';
	const targetIds = ('target_ids' in passed_data && passed_data.target_ids && typeof passed_data.target_ids === 'object') ? passed_data.target_ids : null;
	
	const apiName = process.env.REACT_APP_ENDPOINT_NAME;
	const params = {school_id: schoolId, data_types: dataTypesStringified, schedule_version_id:scheduleVersionID, database:database};
	if(targetIds) params.target_ids = JSON.stringify(targetIds);
    const myInit = { // OPTIONAL
        response: true,
        queryStringParameters: params,
    };
    
    let data_with_connections = dataTypes.reduce((results, data_type) => {
		results[data_type] = [];
		return results;
	}, {});
    
	    try {
			const response = await API.get(apiName, '/load-data', myInit);
			const data_without_connections_by_data_type = response.data;

			if(!data_without_connections_by_data_type || Object.keys(data_without_connections_by_data_type).length <= 0) return data_with_connections;

			// Start with base records so we never drop full datasets if a connections call fails.
			Object.keys(data_without_connections_by_data_type).forEach(data_type => {
				const data_without_connections = Array.isArray(data_without_connections_by_data_type[data_type]) ? data_without_connections_by_data_type[data_type] : [];
				data_with_connections[data_type] = [...data_without_connections];
			});

		// Handle student connections separately because of data size for student requests
		const student_data_index = dataTypes.findIndex(data_type => data_type === 'students');
		if(student_data_index !== -1)
		{
				await loadDataConnections({data_types:['students'], schedule_version_id:scheduleVersionID, data_version_id:dataVersionID, school_id:schoolId, database:database, target_ids: targetIds}).then(connections_by_data_type => {
					const connections_by_type = connections_by_data_type || {};

					// Iterate through data types to start making connections
					Object.keys(data_without_connections_by_data_type).forEach(data_type => {
						if(data_type !== 'students') return;

						// Get the data without connections in this data type
						const data_without_connections = Array.isArray(data_without_connections_by_data_type[data_type]) ? data_without_connections_by_data_type[data_type] : [];

						// Iterate through all data without connections to start adding connections
						data_without_connections.forEach((specific_data, index) => {
							// Get the connections for this data type
							const connections = connections_by_type[data_type] || {};
							const student_requests_map = connections.student_requests || {};
							const student_sections_map = connections.student_sections || {};
							const student_locked_sections_map = connections.student_locked_sections || {};
							const student_labels_map = connections.student_labels || {};
							const student_restrictions_map = connections.student_restrictions || {};
							const teacher_restrictions_map = connections.teacher_restrictions || {};
							const student_lunches_map = connections.student_lunches || {};

							// Add connections for this specific data
							const student_id = specific_data.student_id;
			
							const student_requests = (student_id in student_requests_map) ? student_requests_map[student_id] : [];
							const student_sections = (student_id in student_sections_map) ? student_sections_map[student_id] : [];
							const student_locked_sections = (student_id in student_locked_sections_map) ? student_locked_sections_map[student_id] : [];
							const student_labels = (student_id in student_labels_map) ? student_labels_map[student_id] : [];
							const student_restrictions = (student_id in student_restrictions_map) ? student_restrictions_map[student_id] : [];
							const teacher_restrictions = (student_id in teacher_restrictions_map) ? teacher_restrictions_map[student_id] : [];
							const lunch_schedule_period_id = (student_id in student_lunches_map) ? student_lunches_map[student_id] : null;
						
						if(database === 'edario')
						{	
							specific_data.student_requests = student_requests;
							specific_data.student_sections = student_sections;
							specific_data.student_locked_sections = student_locked_sections;
							specific_data.student_labels = student_labels;
							specific_data.student_restrictions = student_restrictions;
							specific_data.teacher_restrictions = teacher_restrictions;
							specific_data.lunch_schedule_period_id = lunch_schedule_period_id;
						}
						else
						{
							specific_data.student_locked_blocks = student_locked_sections;
						}
			
						data_with_connections[data_type][index] = specific_data;
					});
				});
			});

			dataTypes.splice(student_data_index, 1);
		}

		// If dataTypes is empty after removing students, return the data that has already been processed
		if(dataTypes.length === 0) return data_with_connections;

		// Pull connections for all data types in the dataTypes array
			await loadDataConnections({data_types:dataTypes, schedule_version_id:scheduleVersionID, data_version_id:dataVersionID, school_id:schoolId, database:database, target_ids: targetIds}).then(connections_by_data_type => {
				const connections_by_type = connections_by_data_type || {};

				// Iterate through data types to start making connections
				Object.keys(data_without_connections_by_data_type).forEach(data_type => {
					// Get the data without connections in this data type
					const data_without_connections = Array.isArray(data_without_connections_by_data_type[data_type]) ? data_without_connections_by_data_type[data_type] : [];

					// Iterate through all data without connections to start adding connections
					data_without_connections.forEach((specific_data, index) => {
						// Get the connections for this data type
						const connections = connections_by_type[data_type] || {};

						// Add connections for this specific data
						if(data_type === 'teachers')
						{
							const teacher_id = specific_data.teacher_id;
							const departments_map = connections.departments || {};
							const teacher_can_teach_map = connections.teacher_can_teach || {};
							const classroom_restrictions_map = connections.classroom_restrictions || {};
							const period_restrictions_map = connections.period_restrictions || {};
							const student_restrictions_map = connections.student_restrictions || {};
							const teacher_lunches_map = connections.teacher_lunches || {};
			
							const departments = (teacher_id in departments_map) ? departments_map[teacher_id] : [];
							const teacher_can_teach = (teacher_id in teacher_can_teach_map) ? teacher_can_teach_map[teacher_id] : [];
							const classroom_restrictions = (teacher_id in classroom_restrictions_map) ? classroom_restrictions_map[teacher_id] : [];
							const period_restrictions = (teacher_id in period_restrictions_map) ? period_restrictions_map[teacher_id] : [];
							const student_restrictions = (teacher_id in student_restrictions_map) ? student_restrictions_map[teacher_id] : [];
							const lunch_schedule_period_id = (teacher_id in teacher_lunches_map) ? teacher_lunches_map[teacher_id] : null;
						
						specific_data.teacher_can_teach = teacher_can_teach;

						if(database === 'edario')
						{
							specific_data.classroom_restrictions = classroom_restrictions;
							specific_data.departments = departments;
							specific_data.period_restrictions = period_restrictions;
							specific_data.student_restrictions = student_restrictions;
							specific_data.lunch_schedule_period_id = lunch_schedule_period_id;
						}
						else
						{
							specific_data.day_period_restrictions = period_restrictions;
						}
						
					}
						else if(data_type === 'courses')
						{
							const course_id = specific_data.course_id;
							const departments_map = connections.departments || {};
							const teachers_can_teach_map = connections.teachers_can_teach || {};
							const period_restrictions_map = connections.period_restrictions || {};
							const classroom_restrictions_map = connections.classroom_restrictions || {};
							const course_homerooms_map = connections.course_homerooms || {};
							const pullout_groups_map = connections.pullout_groups || {};
							const pullout_allowed_courses_map = connections.pullout_allowed_courses || {};
			
							const departments = (course_id in departments_map) ? departments_map[course_id] : [];
							const teachers_can_teach = (course_id in teachers_can_teach_map) ? teachers_can_teach_map[course_id] : [];
							const period_restrictions = (course_id in period_restrictions_map) ? period_restrictions_map[course_id] : [];
							const classroom_restrictions = (course_id in classroom_restrictions_map) ? classroom_restrictions_map[course_id] : [];
							const course_homerooms = (course_id in course_homerooms_map) ? course_homerooms_map[course_id] : [];
							const pullout_groups = (course_id in pullout_groups_map) ? pullout_groups_map[course_id] : [];
							const pullout_allowed_courses = (course_id in pullout_allowed_courses_map) ? pullout_allowed_courses_map[course_id] : [];
		
						specific_data.teachers_can_teach = teachers_can_teach;
						specific_data.classroom_restrictions = classroom_restrictions;

						if(database === 'edario')
						{
							specific_data.departments = departments;
							specific_data.period_restrictions = period_restrictions;
						}
						else
						{
							specific_data.day_period_restrictions = period_restrictions;
							specific_data.course_homerooms = course_homerooms;
							specific_data.pullout_groups = pullout_groups;
							specific_data.pullout_allowed_courses = pullout_allowed_courses;
						}
						
					}
						else if(data_type === 'classrooms')
						{
							const classroom_id = specific_data.classroom_id;
							const departments_map = connections.departments || {};
							const course_restrictions_map = connections.course_restrictions || {};
							const teacher_restrictions_map = connections.teacher_restrictions || {};
			
							const departments = (classroom_id in departments_map) ? departments_map[classroom_id] : [];
							const course_restrictions = (classroom_id in course_restrictions_map) ? course_restrictions_map[classroom_id] : [];
							const teacher_restrictions = (classroom_id in teacher_restrictions_map) ? teacher_restrictions_map[classroom_id] : [];
						
						specific_data.course_restrictions = course_restrictions;

						if(database === 'edario')
						{	
							specific_data.departments = departments;
							specific_data.teacher_restrictions = teacher_restrictions;
						}
					}
						else if(data_type === 'departments')
						{
							const department_id = specific_data.department_id;
							const supervisors_map = connections.supervisors || {};

							const supervisors = (department_id in supervisors_map) ? supervisors_map[department_id] : [];

						specific_data.supervisors = supervisors;
					}
		
					data_with_connections[data_type][index] = specific_data;
				});
			});
		});
	} catch(e)
	{
		console.log(e.response);
	}

	return data_with_connections;
}

export const loadSpecificData = async (passed_data) => {
	const schoolId = passed_data.school_id;
	const dataType = passed_data.data_type;
	const dataID = passed_data.data_id;
	const dataVersionID = passed_data.data_version_id;
	const scheduleVersionID = passed_data.schedule_version_id;
	const database = ('database' in passed_data) ? passed_data.database : 'edario';

	const apiName = process.env.REACT_APP_ENDPOINT_NAME;
	const url = '/load-specific-data';
	const params = {school_id:schoolId, data_type:dataType, data_version_id:dataVersionID, schedule_version_id:scheduleVersionID, data_id:dataID, database:database};
    const myInit = { // OPTIONAL
        response: true,
        queryStringParameters: params,
    };
    
    let data;
    
    try {
		const response = await API.get(apiName, url, myInit);
		data = response.data;
	} catch(e)
	{
		console.log(e.response);
	}
	
	return data;
}

export const deleteData = async (data, options = {}) => {
	const throwOnError = options.throwOnError === true;
	const apiName = process.env.REACT_APP_ENDPOINT_NAME;
	const url ='/admin/delete-data';
    const myInit = { // OPTIONAL
        response: true,
        body: JSON.stringify(data),
    };
    
	let response_data;

	try
	{
		const response = await API.post(apiName, url, myInit);
		response_data = response.data;
	}
	catch(e)
	{
		console.log(e.response);
		if(throwOnError) throw e;
		return null;
	}

	if(data.data_type === 'student')
	{
		const not_deleted_id_set = new Set(
			Array.isArray(response_data?.not_deleted_ids)
				? response_data.not_deleted_ids.map((not_deleted_id) => `${not_deleted_id}`)
				: []
		);
		const deleted_ids = (
			Array.isArray(response_data?.deleted_ids) ? response_data.deleted_ids : (Array.isArray(data.data_ids) ? data.data_ids : [])
		).map((deleted_id) => `${deleted_id}`).filter((deleted_id) => deleted_id && !not_deleted_id_set.has(deleted_id));

		if(deleted_ids.length > 0)
		{
			notifyHSMSDataMutation({
				school_id: data.school_id,
				schedule_version_id: data.schedule_version_id,
				slices: ['students'],
				targets: {
					type: 'student_save',
					students: {
						deleted_ids: deleted_ids,
					},
				},
				reason: 'delete_data:student',
			});
		}

		notifyHSMSDataMutation({
			school_id: data.school_id,
			schedule_version_id: data.schedule_version_id,
			slices: ['sections'],
			reason: 'delete_data:student_sections',
		});
	}
	else
	{
		notifyHSMSDataMutation({
			school_id: data.school_id,
			schedule_version_id: data.schedule_version_id,
			mutation_type: 'delete_data',
			data_type: data.data_type,
			reason: `delete_data:${data.data_type}`,
		});
	}
	
	return response_data;
}

export const getNextAppScreen = async (passed_data) => {
	const school_id = passed_data.school_id;
	const completed_subscreen = passed_data.completed_subscreen;
	const schedule_version_id = passed_data.schedule_version_id;
	const database = ('database' in passed_data) ? passed_data.database : 'edario';
	const _callback = ('callback' in passed_data) ? passed_data.callback : ()=>{};

	const data = {school_id:school_id, schedule_version_id:schedule_version_id, completed_subscreen: completed_subscreen, database:database};
	
	const apiName = process.env.REACT_APP_ENDPOINT_NAME;
	const url = '/get-next-app-screen'
    const myInit = { // OPTIONAL
        response: true,
        body: JSON.stringify(data),
    };
    
    const response = await API.post(apiName, url, myInit);
    const result = response.data;
	
	_callback(result);
}

export const getNotifications = async (params = {}) => {
	const apiName = process.env.REACT_APP_ENDPOINT_NAME;
    const myInit = { // OPTIONAL
        response: true,
        queryStringParameters: params,
    };
    
    let notifications;
    	
	try {
		const response = await API.get(apiName, '/get-notifications', myInit);
		notifications = response.data;
	} catch(e)
	{
		console.log(e.response);
	}
			
	return notifications;
}

export const updateDepartment = async (passed_data) => {
	const school_id = ('school_id' in passed_data) ? passed_data.school_id : null;
	const schedule_version_id = ('schedule_version_id' in passed_data) ? passed_data.schedule_version_id : null;
	const update_type = ('update_type' in passed_data) ? passed_data.update_type : null;
	const department_id = ('department_id' in passed_data) ? passed_data.department_id : null;
	const department = ('department' in passed_data) ? passed_data.department : null;
	const user_id = ('user_id' in passed_data) ? passed_data.user_id : null;
	const allow_cross_department_editing = ('allow_cross_department_editing' in passed_data) ? passed_data.allow_cross_department_editing : null;

	const data = {school_id: school_id, schedule_version_id:schedule_version_id, update_type:update_type, department_id:department_id, department:department, user_id:user_id, allow_cross_department_editing:allow_cross_department_editing};
	const apiName = process.env.REACT_APP_ENDPOINT_NAME;
	const url = '/admin/update-department'
    const myInit = { // OPTIONAL
        response: true,
        body: JSON.stringify(data),
    };
    
    const response = await API.post(apiName, url, myInit);

	notifyHSMSDataMutation({
		school_id: school_id,
		schedule_version_id: schedule_version_id,
		mutation_type: 'settings',
		data_type: 'department',
		reason: `update_department:${update_type || 'update'}`,
	});
	
	return response.data;	    
} 

export const updateNotification = async (update_type, school_id, schedule_year_id, notification_id = null, subscreen_id = null, department_id = null, notification = null, for_admin = false) => {
	const data = {school_id: school_id, schedule_year_id:schedule_year_id, update_type:update_type, notification_id:notification_id};
	const apiName = process.env.REACT_APP_ENDPOINT_NAME;
	const url = '/update-notification'
    const myInit = { // OPTIONAL
        response: true,
        body: JSON.stringify(data),
    };
    
    await API.post(apiName, url, myInit);
    
    const notifications = getNotifications({school_id: school_id, schedule_year_id:schedule_year_id});
	
	return notifications;
}

export const updateNote = async (passed_data) => {
	const school_id = ('school_id' in passed_data) ? passed_data.school_id : null; 
	const update_type = ('update_type' in passed_data) ? passed_data.update_type : null;
	const note_id = ('note_id' in passed_data) ? passed_data.note_id : null;
	const schedule_version_id = ('schedule_version_id' in passed_data) ? passed_data.schedule_version_id : null;
	const subscreen = ('subscreen' in passed_data) ? passed_data.subscreen : null; 
	const department_id = ('department_id' in passed_data) ? passed_data.department_id : null;
	const user_id = ('user_id' in passed_data) ? passed_data.user_id : null;
	const note = ('note' in passed_data) ? passed_data.note : null;
	const tagged_users = ('tagged_users' in passed_data) ? passed_data.tagged_users : null;

	const data = {school_id:school_id, update_type:update_type, note_id:note_id, schedule_version_id:schedule_version_id, subscreen:subscreen, department_id:department_id, user_id:user_id, note:note, tagged_users:tagged_users};
	const apiName = process.env.REACT_APP_ENDPOINT_NAME;
	const url = '/update-note'
    const myInit = { // OPTIONAL
        response: true,
        body: JSON.stringify(data),
    };
    
	const response = await API.post(apiName, url, myInit);

	return response.data;
}

export const saveSectionPlacement = async (data) => {
	const apiName = process.env.REACT_APP_ENDPOINT_NAME;
	const url = '/save-section-placement';
    const myInit = { // OPTIONAL
        response: true,
        body: JSON.stringify(data),
    };
    
	const response = await API.post(apiName, url, myInit);

	if(response.data?.refresh_targets)
	{
		notifyHSMSDataMutation({
			school_id: data.school_id,
			schedule_version_id: data.schedule_version_id,
			slices: ['sections', 'subsections'],
			targets: response.data.refresh_targets,
			reason: 'save_section_placement',
		});
	}

	return response.data;
}

let localConflictFixtureContext = null;

const getLocalConflictFixturePreset = () => {
	if(process.env.NODE_ENV !== 'development') return null;
	const preset = `${process.env.REACT_APP_LOCAL_CONFLICT_FIXTURE_PRESET || ''}`.trim().toLowerCase();
	return (preset === 'empty' || preset === 'sample') ? preset : null;
}

const dedupeArray = (items = []) => {
	return Array.from(new Set(items.filter(item => item !== null && item !== undefined && item !== '')));
}

const buildLocalConflictFixtureResponse = (data = {}, context = null) => {
	const conflicts_to_check = Array.isArray(data.conflicts_to_check) ? data.conflicts_to_check : [];
	const preset = getLocalConflictFixturePreset();
	if(!preset) return { conflicts: [] };
	if(preset === 'empty') return { conflicts: [] };

	const sections = Array.isArray(context?.sections) ? context.sections : [];
	const students = Array.isArray(context?.students) ? context.students : [];
	const scheduled_sections = sections.filter(section => Array.isArray(section?.course_periods) && section.course_periods.length > 0);
	const available_sections = scheduled_sections.length > 0 ? scheduled_sections : sections;

	const primary_section = available_sections[0] || null;
	const secondary_section = available_sections[1] || primary_section;
	const tertiary_section = available_sections[2] || secondary_section || primary_section;
	const primary_section_id = primary_section ? `${primary_section.section_id}` : null;
	const secondary_section_id = secondary_section ? `${secondary_section.section_id}` : primary_section_id;
	const tertiary_section_id = tertiary_section ? `${tertiary_section.section_id}` : secondary_section_id;
	const primary_student_id = Array.isArray(primary_section?.student_list) && primary_section.student_list.length > 0
		? `${primary_section.student_list[0]}`
		: (students[0]?.student_id ? `${students[0].student_id}` : null);

	const sample_conflicts = [
		{
			conflict_id: 'local-fixture-teacher-double-booked',
			type: 'teacher_double_booked',
			sections: dedupeArray([primary_section_id, secondary_section_id]),
			hard_conflict: '1',
			ignored: false,
		},
		{
			conflict_id: 'local-fixture-student-double-booked',
			type: 'student_double_booked',
			sections: dedupeArray([primary_section_id, secondary_section_id]),
			students: dedupeArray([primary_student_id]),
			hard_conflict: '1',
			ignored: false,
		},
		{
			conflict_id: 'local-fixture-course-period-restriction',
			type: 'course_period_restriction',
			sections: dedupeArray([primary_section_id]),
			hard_conflict: '0',
			ignored: false,
		},
		{
			conflict_id: 'local-fixture-teacher-period-restriction',
			type: 'teacher_period_restriction',
			sections: dedupeArray([secondary_section_id]),
			hard_conflict: '0',
			ignored: false,
		},
		{
			conflict_id: 'local-fixture-classroom-exceeds-capacity',
			type: 'classroom_exceeds_capacity',
			sections: dedupeArray([tertiary_section_id]),
			hard_conflict: '0',
			ignored: false,
		},
		{
			conflict_id: 'local-fixture-ignored-conflict',
			type: 'classroom_double_booked',
			sections: dedupeArray([secondary_section_id, tertiary_section_id]),
			hard_conflict: '1',
			ignored: true,
		},
		{
			conflict_id: 'local-fixture-ignored-warning',
			type: 'teacher_too_many_sections',
			sections: dedupeArray([primary_section_id, secondary_section_id, tertiary_section_id]),
			hard_conflict: '0',
			ignored: true,
		},
	].filter(conflict => Array.isArray(conflict.sections) && conflict.sections.length > 0);

	const filtered_conflicts = conflicts_to_check.length > 0
		? sample_conflicts.filter(conflict => conflicts_to_check.includes(conflict.type))
		: sample_conflicts;

	return { conflicts: filtered_conflicts };
}

export const setLocalConflictFixtureContext = (context = null) => {
	localConflictFixtureContext = context;
}

export const calculateConflicts = async (data) => {
	const affected_sections = data.affected_sections && Array.isArray(data.affected_sections) ? data.affected_sections : undefined;
	const affected_blocks = data.affected_blocks && Array.isArray(data.affected_blocks) ? data.affected_blocks : undefined;
	const conflicts_to_check = data.conflicts_to_check && Array.isArray(data.conflicts_to_check) ? data.conflicts_to_check : [];
	const database = data.database ? data.database : undefined;
	const match_percent = data.match_percent ? data.match_percent : false;
	const student_list = data.student_list && Array.isArray(data.student_list) ? data.student_list : undefined;
	const update_all = typeof data.update_all !== 'undefined' ? data.update_all : undefined;
	const local_fixture_context = data.local_fixture_context ? data.local_fixture_context : localConflictFixtureContext;
	const local_fixture_preset = getLocalConflictFixturePreset();
	const diagnostics_enabled = typeof window !== 'undefined' && window.localStorage && window.localStorage.getItem('edario_conflict_diagnostics') === '1';
	const request_started_at = Date.now();

	if(local_fixture_preset) return buildLocalConflictFixtureResponse(data, local_fixture_context);
	
	const apiName = process.env.REACT_APP_ENDPOINT_NAME_V2;
	const url = '/conflicts/calculate';
	const myInit = {
		response: true,
		body: {
			database,
			school_id: data.school_id,
			schedule_version_id: data.schedule_version_id,
			conflicts_to_check: conflicts_to_check,
			affected_sections: affected_sections,
			affected_blocks: affected_blocks,
			match_percent: match_percent,
			student_list: student_list,
			update_all: update_all,
		}
	};

	try {
		const response = await API.post(apiName, url, myInit);
		const request_duration_ms = Date.now() - request_started_at;
		if(diagnostics_enabled || request_duration_ms > 5000) {
			console.info('[conflicts/calculate]', {
				duration_ms: request_duration_ms,
				school_id: data.school_id,
				schedule_version_id: data.schedule_version_id,
				conflicts_to_check_count: conflicts_to_check.length,
				affected_sections_count: affected_sections ? affected_sections.length : 0,
				match_percent,
				update_all,
				conflicts_returned: Array.isArray(response?.data?.conflicts) ? response.data.conflicts.length : null,
			});
		}

		return response.data;
	} catch(error) {
		const request_duration_ms = Date.now() - request_started_at;
		if(diagnostics_enabled || request_duration_ms > 5000) {
			console.info('[conflicts/calculate failed]', {
				duration_ms: request_duration_ms,
				school_id: data.school_id,
				schedule_version_id: data.schedule_version_id,
				conflicts_to_check_count: conflicts_to_check.length,
				affected_sections_count: affected_sections ? affected_sections.length : 0,
				match_percent,
				update_all,
				error: error?.response || error,
			});
		}

		if(process.env.NODE_ENV === 'development') {
			console.warn('calculateConflicts failed in development, returning empty local conflicts.', error?.response || error);
			return buildLocalConflictFixtureResponse({ ...data, conflicts_to_check }, local_fixture_context);
		}

		throw error;
	}
}

export const updateConflicts = async (data) => {
	try {
		const apiName = process.env.REACT_APP_ENDPOINT_NAME_V2;
		const url = data.update === 'ignore' ? '/conflicts/ignore' : '/conflicts/ignore/delete';
		const myInit = {
			response: true,
			body: {
				...data
			},
		};

		const response = await API.post(apiName, url, myInit);

		return response.data;
	} catch(e) {
		console.log(e);
		throw e;
	}
}

export const deleteSection = async (data) => {
	// Update database
	const apiName = process.env.REACT_APP_ENDPOINT_NAME;
	const url = '/admin/delete-section';
	const myInit = { // OPTIONAL
		response: true,
		body: JSON.stringify(data),
	};
   
	try {
		const result = await API.post(apiName, url, myInit);
		const response_data = result.data;
		
		return response_data;
	} catch(e)
	{
		console.log(e.response);
	}
}

export const studentValidateRequests = async (school_id, schedule_version_id, student_requests) => {
	try {
		const apiName = process.env.REACT_APP_ENDPOINT_NAME_V2;
		const url = '/student/request/validate';
		const myInit = {
			response: true,
			body: {
				school_id,
				schedule_version_id,
				student_requests
			},
		};

		const response = await API.post(apiName, url, myInit);

		return response.data;
	} catch(e) {
		console.log(e);
		throw e;
	}
}

export const saveStudentSchedule = async (data) => {
	try {
		const apiName = process.env.REACT_APP_ENDPOINT_NAME_V2;
		const url = '/student/schedule';
		const myInit = {
			response: true,
			body: data,
		};

		const response = await API.put(apiName, url, myInit);

		return response.data;
	} catch(e) {
		console.log(e);
		throw e;
	}
}

export const loadCourseIcons = async (school_id, data_version_id) => {
	try {
		const apiName = process.env.REACT_APP_ENDPOINT_NAME;
		const url = '/get-course-icons';
		const myInit = {
			response: true,
			queryStringParameters: {
				school_id,
				data_version_id,
			},
		};

		const response = await API.get(apiName, url, myInit);
		return response.data;
	} catch(e) {
		console.log(e);
		throw e;
	}
}

export const getSections = async ({ school_id, schedule_version_id, course_id = null, placed = false, labs = false }) => {
	try {
		const apiName = process.env.REACT_APP_ENDPOINT_NAME_V2;
		const url = '/sections';
		const myInit = {
			response: true,
			queryStringParameters: {
				school_id,
				schedule_version_id,
				course_id,
				placed,
				labs,
			},
		};

		const response = await API.get(apiName, url, myInit);

		return response.data;
	} catch(e) {
		console.log(e);
		throw e;
	}
}

export const createLabSections = async ({ school_id, schedule_version_id, main_sections_ids }) => {
	try {
		const apiName = process.env.REACT_APP_ENDPOINT_NAME_V2;
		const url = '/sections/create/labs';
		const myInit = {
			response: true,
			body: {
				school_id,
				schedule_version_id,
				main_sections_ids,
			},
		};

		const response = await API.post(apiName, url, myInit);

		return response.data;
	} catch(e) {
		console.log(e);
		throw e;
	}
}

export const updateManualPlacement = async ({ school_id, schedule_version_id, department_id, update_type, section_info, new_course_period_id, current_day }) => {
	try {
		const data = {
			school_id: school_id, 
			schedule_version_id: schedule_version_id, 
			department_id: department_id, 
			update_type: update_type, 
			section_info: section_info, 
			new_course_period_id: new_course_period_id, 
			current_day: current_day
		};
    
    const apiName = process.env.REACT_APP_ENDPOINT_NAME;
    const url = '/admin/update-manual-placement';
    const myInit = { // OPTIONAL
      response: true,
      body: JSON.stringify(data),
    };

		const result = await API.post(apiName, url, myInit);
		const response_data = result.data;

		return response_data;
	} catch(e) {
		console.log(e);
		throw e;
	}

		
};
